export interface Article {
  id: number;
  category: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  slug: string;
}

export const BLOG_ARTICLES: Article[] = [
  {
    id: 1,
    category: 'EDW Fundamentals',
    title: 'What is Enterprise Data Warehousing? A Complete Guide',
    excerpt: 'Discover the fundamentals of enterprise data warehousing and how it transforms business intelligence capabilities for modern organizations.',
    author: 'Sarah Mitchell',
    date: 'Jan 15, 2026',
    readTime: '8 min read',
    image: '/assets/images/no_image.png',
    slug: 'what-is-enterprise-data-warehousing',
  },
  {
    id: 2,
    category: 'EDW Fundamentals',
    title: 'Data Warehouse vs Data Lake: Which is Right for Your Business?',
    excerpt: 'Compare data warehouses and data lakes to understand which architecture best fits your organization\'s data strategy and business needs.',
    author: 'Michael Chen',
    date: 'Jan 12, 2026',
    readTime: '10 min read',
    image: '/assets/images/no_image.png',
    slug: 'data-warehouse-vs-data-lake',
  },
  {
    id: 3,
    category: 'Industry Insights',
    title: 'Pharmaceutical Data Challenges: From Batch Tracking to Compliance',
    excerpt: 'Understand the unique data challenges pharmaceutical companies face and how enterprise data warehouses ensure regulatory compliance.',
    author: 'Dr. Emily Watson',
    date: 'Jan 18, 2026',
    readTime: '9 min read',
    image: '/assets/images/no_image.png',
    slug: 'pharmaceutical-data-challenges',
  },
  {
    id: 4,
    category: 'Implementation',
    title: 'Preparing Your Organization for Enterprise Data Warehouse Implementation',
    excerpt: 'A comprehensive guide to organizational readiness, stakeholder alignment, and change management for successful EDW deployment.',
    author: 'Laura Bennett',
    date: 'Jan 20, 2026',
    readTime: '11 min read',
    image: '/assets/images/no_image.png',
    slug: 'preparing-organization-edw-implementation',
  },
  {
    id: 5,
    category: 'Technology',
    title: 'Snowflake vs Redshift vs BigQuery: Cloud Data Warehouse Comparison',
    excerpt: 'An in-depth technical comparison of leading cloud data warehouse platforms to help you choose the right solution for your needs.',
    author: 'Kevin Zhang',
    date: 'Jan 19, 2026',
    readTime: '12 min read',
    image: '/assets/images/no_image.png',
    slug: 'snowflake-redshift-bigquery-comparison',
  },
  {
    id: 6,
    category: 'Leadership',
    title: 'CFO\'s Guide to Data Warehouse ROI: Measuring Success',
    excerpt: 'Financial leaders learn how to quantify data warehouse value, track ROI metrics, and justify continued investment in data infrastructure.',
    author: 'Thomas Reynolds',
    date: 'Jan 21, 2026',
    readTime: '10 min read',
    image: '/assets/images/no_image.png',
    slug: 'cfo-guide-data-warehouse-roi',
  },
];

export const BLOG_CATEGORIES = [
  'All',
  'EDW Fundamentals',
  'Industry Insights',
  'Implementation',
  'Technology',
  'Leadership',
];
